import React, { useEffect } from 'react';
import Text from '@service-victoria/component-library/components/Text';
import Page from '@service-victoria/component-library/components/Page';
import * as Styled from '../../steps/styled';
import { constants, storage } from 'utils';
import { TextBodyWithInlineLink } from './styled';
import bannerImg from 'assets/melbourne-city-at-night.png';

const TechnicalError: React.FC = () => {
  useEffect(() => {
    storage.clear();
  }, []);

  return (
    <Page
      title={constants.Page.title}
      showFooter={true}
      breadCrumbs={constants.breadCrumbs}
      imgUrl={bannerImg}>
      <Styled.Wrapper>
        <Styled.HeadingWrapper>
          <Text.Heading.H1 fontWeight='bold'>Technical Error</Text.Heading.H1>
          <Styled.Spacer24 />
        </Styled.HeadingWrapper>
        <Styled.Spacer24 />
        <Text.Body>
          <TextBodyWithInlineLink>
            Sorry. The melbourne travel voucher system is experiencing significant demand. Please
            wait a moment and{' '}
            <Text.Link href={constants.externalLinks.siteRelAppHomePath} value='try again' />.
          </TextBodyWithInlineLink>
        </Text.Body>
      </Styled.Wrapper>
    </Page>
  );
};

export default TechnicalError;
